import React from "react"
import { ColorWorker } from '@capture/color-theme-core';
import Select from '@react/react-spectrum/Select';
import ThumbsUpDown from "../components/ThumbsUpDown"
import DownloadTopPanel from "../components/DownloadTopPanel"
import Draggable from 'react-draggable';
import Button from '@react/react-spectrum/Button'
import Clipboard from "@react/react-spectrum/Icon/Copy"
import update from 'react-addons-update'; // ES6
import Header from "../components/headers/Header"
let _colorWorker;

export default class Test extends React.Component {
    constructor() {
        super();
        _colorWorker = new ColorWorker();
        this.state = {
            scrollY:0,
            scrollX:0,
            width: 750,
            height: 550,
            rgb: "",
            ctx: null,
            windowWidth: 0,
            windowHeight: 0,
            imgWidth: 0,
            imgHeight: 0,
            count: 5,
            mood: "Colorful",
            swatches: [],
            markers: [],
            imageLoaded: false
        }
        this.swatchColors = []
        this._extractColors = this._extractColors.bind(this)
    }
    componentDidMount() {
        this.displayWindowSize()
        this.setState({ image: this.props.image.image, imageLoaded: true })
        window.addEventListener("resize", this.displayWindowSize);
        window.addEventListener("scroll",this.handleScroll)
    }
    handleScroll = () => {
        let y = window.scrollY
        this.setState({
            scrollY:y
        })
        let x = window.scrollX
        this.setState({
            scrollX:x
        })
    }
    displayWindowSize = () => {
        const canvas = this.refs.canvas
        console.log(canvas)
        let x = canvas.getBoundingClientRect().x
        let y = canvas.getBoundingClientRect().y
        this.setState({
            canvasX: x,
            canvasY: y
        })
    }
    imageLoaded = () => {
        window.addEventListener('resize', this.updateWindowDimensions);
        const img = this.refs.image
        img.onload = () => {
            const canvas = this.refs.canvas
            const ctx = canvas.getContext("2d")
            const canvas2 = this.refs.canvas2
            const ctx2 = canvas2.getContext("2d")
            canvas2.width = 750
            canvas2.height = 550
            canvas.width = img.width
            canvas.height = img.height
            //find x and y of current canvas 
            let x = canvas.getBoundingClientRect().x
            let y = canvas.getBoundingClientRect().y
            // getting image data for original image
            // ctx.drawImage(img,0,0)
            ctx.drawImage(img, 0, 0, img.width, img.height);
            ctx2.drawImage(img, 0, 0, img.width, img.height,
                0, 0, canvas2.width, canvas2.height);
            let data2 = ctx2.getImageData(0, 0, img.width, img.height)
            this.setState({
                ctx2: ctx2
            })
            let data = ctx.getImageData(0, 0, img.width, img.height)
            this.setState({
                imageData: data,
                ctx: ctx,
                width: img.width,
                height: img.height,
                canvasX: x,
                canvasY: y
            })
        }
    }
    componentDidUpdate(prevprops, prevState) {
        const { state } = this
        if (state.image !== prevState.image) {
            this.imageLoaded()
        }
        if (state.imageData !== prevState.imageData || state.mood !== prevState.mood) {
            this._extractColors(state.imageData, state.imageData.width, state.imageData.height, state.count, state.mood)
        }
    }
  
    _extractColors(imageData, width, height, count, mood) {
        let extractionMessage = { imageData, width, height, swatchCount: count, colorMood: mood };
        _colorWorker.onmessage = extractedData => {
            const swatches = [];
            const markers = [];
            extractedData.data.points.forEach(point => {
                markers.push({
                    x: point.x,
                    y: point.y
                });
            });
            extractedData.data.finalColor.forEach(color => {
                swatches.push({
                    r: Math.round(color.rgb.r * 255),
                    g: Math.round(color.rgb.g * 255),
                    b: Math.round(color.rgb.b * 255)
                });
            });
            this.setState({ imageLoaded: true, swatches: swatches, markers: markers });
        };
        _colorWorker.postMessage(extractionMessage);
    }
    handleDrag = (event, marker) => {
        const { ctx2, canvasX, canvasY, scrollX,scrollY} = this.state
        let id = (event.target.id)
        // subtracting the marker position with the canvas x and y position  
        let x = event.clientX - canvasX + scrollX
        let y = event.clientY - canvasY + scrollY
        const data = ctx2.getImageData(x, y, 1, 1).data
        const hexValue = this.rgbToHex(data[0], data[1], data[2])
        marker.node.style.backgroundColor = hexValue
        this.setState({ rgb: hexValue })
        this.setState({
            swatches: update(this.state.swatches, { [id]: { $set: { r: data[0], g: data[1], b: data[2] } } })
        })
    }
    componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }
    rgbToHex(r, g, b) {
        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    }
    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }
    colorMarkers = () => {
        const { markers, imageData, windowWidth } = this.state
        const { height, width } = imageData
        let colorValues = this.state.swatches.map((swatch, i) => {
            return this.rgbToHex(swatch.r, swatch.g, swatch.b)
        })
        return markers.map((marker, i) => {
            return (
                <Draggable
                    bounds="parent"
                    onDrag={this.handleDrag}
                    key={i}
                >
                    <div id={i} key={i} className="markers"
                        style={{
                            position: "absolute",
                            backgroundColor: colorValues[i],
                            left: (750) / width * (marker.x) -10,
                            top: 550 / height * (marker.y) -10,
                            borderRadius: 100,

                        }}>
                        +
              </div>
                </Draggable>
            )
        })
    }
    colorSwatches = () => {
        let colorValues = []
        let swatches = []
        swatches = this.state.swatches.map((swatch, i) => {
            let colorValue = this.rgbToHex(swatch.r, swatch.g, swatch.b)
            return (
                <div key={i} class="swatches">
                    <div class = "swatchBox">
                    <div class="swatch" style={{ backgroundColor: colorValue }}>
                    </div>
                        <p ref={`swatchCode${i}`}>{this.rgbToHex(swatch.r, swatch.g, swatch.b).toUpperCase()}</p>
                        </div>
                        {/* // logical support do display copy if supported */}
                        {document.queryCommandSupported('copy') && <div className="copy" onClick={() => this.handleCopy(i)}>
                            <Clipboard />
                        </div>
                        }
                </div>
            )
        })
        colorValues = this.state.swatches.map((swatch, i) => {
            //rgb color values of the swatches 
            return this.rgbToHex(swatch.r, swatch.g, swatch.b)
        })
        this.swatchColors = colorValues
        return swatches
    }
    handleCopy = (id) => {
        let swatchCode = `swatchCode${id}`
        let text = this.refs[swatchCode].innerText
        var dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.setAttribute('value', text);
        dummy.select();
        document.execCommand("copy");
        alert(`Text copied: ${text}`)
        document.body.removeChild(dummy);
    }
    handleMood = (e) => {
        this.setState({ mood: e })
    }
    handleUpload = (e) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0];
            let src = URL.createObjectURL(img);
            this.setState({
                image: src,
                loaded: true
            });
        }
    }
    circleSwatches = () => {
        let swatches = this.state.swatches.map((swatch, i) => {
            let colorValue = this.rgbToHex(swatch.r, swatch.g, swatch.b)
            return (
                <div key={i} style={{ backgroundColor: colorValue }} className="circleSwatch" >
                </div>
            )
        })
        return (
            <div style={{ width: 147 }}>
                <p>Swatches</p>
                <div className="circles">
                    {swatches}
                </div>
            </div>
        )
    }
    moodPicker = () => {
        return (
            <div>
                <p>Color Mood </p>
                <Select name="moods" onChange={this.handleMood} defaultValue={"Colorful"}
                    options={[
                        {
                            label: 'Colorful',
                            value: 'Colorful'
                        },
                        {
                            label: 'Bright',
                            value: 'Bright'
                        },
                        {
                            label: 'Muted',
                            value: 'Muted'
                        },
                        {
                            label: 'Deep',
                            value: 'Deep'
                        },
                        {
                            label: 'Dark',
                            value: 'Dark'
                        }
                    ]}>
                </Select>
            </div>
        )
    }
    render() {
        const { state } = this
        return (
            <>
            <div class="colorTheme">
                <div class="downloadedPanelColor">
                    <div class="firstColorPanel">
                        <DownloadTopPanel title={this.props.image.title} desc={this.props.image.desc} />
                    <div className="downloadButtonsColor" >
                        <Button variant="cta" onClick={this.handleSave}> Download </Button>
                        <input type="file" name="imgUpload" ref="file" className="inputfile" onChange={this.handleUpload}
                            accept=".png,.jpg"
                        />
                        <Button onClick={() => this.refs.file.click()}>Add new</Button>
                    </div>
                    <div className="colorSwatches">
                        {state.imageData ? this.colorSwatches() : null}
                    </div>
                </div>
                <ThumbsUpDown title="color" />
            </div>
            <div style={{ position: 'relative', width: 750, height: 550 }}>
                <canvas className="capture-canvas" ref="canvas" style={{ width: 750, height: 550 }} />
                <canvas className="capture-canvas" ref="canvas2" style={{ width: 750, height: 550, display: "none" }} />
                {state.imageLoaded ? <img ref="image" src={state.image} style={{ visibility: 'hidden',objectFit: 'cover' }} /> : null}
                {/* {adding key to reset colorMarkers whenever state.mood is changed} */}
                <div key={state.mood} style={{ width: 750, height: 550 }}>
                    {state.imageData ? this.colorMarkers() : null}
                </div>
                <div className="moodPicker">
                    {this.moodPicker()}
                    {this.circleSwatches()}
                </div>
            </div>
            </div>
            </>
        )
    }
}